module.exports = __webpack_public_path__ + "static/img/loading_iSpt.788745a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme1/common/loading_iSpt.png
// module id = 4fTm
// module chunks = 319